<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div
        class="modal"
        role="dialog"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Add to Calender</h4>
            <button
              type="button"
              @click="close"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-body">
              <div class="row">
                <div class="col-md-12">
                  <label :class="['control-label']">
                    Perihal / Title
                    <small style="color: red">*</small>
                  </label>
                  <div>
                    <textarea
                      :value="this.dataCalendar.subject"
                      name="subject"
                      placeholder="Perihal"
                      required
                      :class="[
                        'form-control',
                        { 'form-control-danger': errors.has('subject') },
                      ]"
                    ></textarea>
                    <small
                      class="form-control-feedback"
                      v-show="errors.has('subject')"
                      >this field is required</small>
                  </div>
                </div>
                <div class="col-md-12">
                  <label :class="['control-label']">
                    Tanggal 
                    <small style="color: red">*</small>
                  </label>
                  <div>
                    <!-- <CustomInput
                      :required="true"
                      label="Tanggal"
                      type="date"
                      size="4"
                      :model="this.dataCalendar.tanggal_sla"
                    /> -->
                    <Input
                        :value="this.dataCalendar.tanggal_sla"
                        name="tanggal_sla"
                        placeholder="YYYY-MM-DD"
                        required
                        type="date"
                        class="form-control"
                    />
                    <small
                      class="form-control-feedback"
                      v-show="errors.has('date')"
                      >this field is required</small>
                  </div>
                </div>
              <!-- <span>Last Info : {{ this.dataCalendar.tekenaja_status_text }}</span> -->
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-warning" @click="add">Tambah ke Kalender</button>
            <button type="button" class="btn btn-danger" data-dismiss="modal" @click="close(false)">Kembali</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import axios from "axios";
export default {
  props: ["dataCalendar"],
  data() {
    return {
      isDisabled:false
    };
  },
  computed: {
  },
  mounted() {
  },
  methods: {
    
    async add() {
      const payload = this.dataCalendar;
      const params = {subject:payload.subject,tanggal_sla:payload.tanggal_sla};
      console.log(payload);
      console.log(params);
      try {
        await axios.post(`document_in/add_calender`, params );
        this.notifSuccess({
          title: "Success",
          text: "Data berhasil dikirim",
        });
      } catch {
        this.notifError({
          title: "Error",
          text: "Gagal mengirim data",
        });
      } finally {
        this.close();
      }
    },
    close(val) {
      this.$emit("close",val);
    }
  },
};
</script>
<style>
.modal-backdrop {
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: #ffffff;
  position: relative !important;
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
}

.modal-header,
.modal-footer {
  padding: 15px;
  display: flex;
}

.modal-header {
  border-bottom: 1px solid #eeeeee;
  color: #4aae9b;
  justify-content: space-between;
}

.modal-footer {
  border-top: 1px solid #eeeeee;
  justify-content: flex-end;
}

.modal-body {
  position: relative;
  padding: 20px 10px;
}

.btn-close {
  border: none;
  font-size: 20px;
  padding: 20px;
  cursor: pointer;
  font-weight: bold;
  color: #4aae9b;
  background: transparent;
}

.btn-green {
  color: white;
  background: #4aae9b;
  border: 1px solid #4aae9b;
  border-radius: 2px;
}
.modal-fade-enter,
.modal-fade-leave-active {
  opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.5s ease;
}
</style>